"use client";
import { motion } from "framer-motion";

interface RoomTravelersSelectorSkeletonProps {
    title?: string;
    icon?: React.ReactNode;
}

export default function RoomTravelersSelectorSkeleton({ 
    title, 
    icon 
}: RoomTravelersSelectorSkeletonProps) {
    return (
        <motion.div
            initial={false}
            animate={{ opacity: 1, y: 0 }}
            className="w-full relative z-90"
        >
            {title && (
                <label className="text-alsero-dark-gray text-base sm:text-lg mb-1 block">
                    {title}
                </label>
            )}
            
            <div className="relative flex flex-row justify-between items-center px-4 sm:px-6 py-3 bg-white rounded-lg w-full min-h-[50px] sm:min-h-[60px]">
                <div className="flex flex-row gap-2 items-center">
                    {icon && (
                        <div className="flex-shrink-0 opacity-50">
                            {icon}
                        </div>
                    )}
                    <div className="h-5 w-8 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-pulse" />
                </div>
                <div className="w-4 h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-pulse" />
            </div>
        </motion.div>
    );
}

